import { Component, OnInit, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { GrupoUsuarioService } from 'src/services/grupo-usuario.service';
import { PermissoesService } from 'src/services/permissoes.service';
import { PessoaService } from 'src/services/pessoa.service';
import { UsuarioService } from 'src/services/usuario.service';
import { ConfirmationService } from 'primeng/api';
import { distinctUntilChanged, Subscription } from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser';
import { UploadService } from 'src/services/upload.service';

@Component({
    selector: 'app-credenciais-api',
    templateUrl: './credenciais-api.component.html',
    styleUrls: ['./credenciais-api.component.scss'],
    standalone: false
})
export class CredenciaisApiComponent implements OnInit, AfterViewInit {
  data: any[] = []
  form: FormGroup;
  formApi: FormGroup;
  displayModal: boolean = false
  displayModalApi: boolean = false
  apiKeyDownloaded: boolean = false;
  secretDownloaded: boolean = false;
  isEditing: boolean = false;
  loading: boolean = false
  dropDownEmpresas: any[] = []
  dropDownGrupos: any[] = []
  newImagePreview: any;
  selectedImageFile: File | null = null;
  isUploading = false;
  @ViewChild('tableWrapper', { static: false }) tableWrapper: ElementRef;
  scrollHeight: string = '600px';

  private empresaIdSubscription: Subscription;
  constructor(
    protected _formBuilder: FormBuilder,
    protected usuarioService: UsuarioService,
    protected pessoaService: PessoaService,
    protected _grupoUsuarioService: GrupoUsuarioService,
    protected permissaoService: PermissoesService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private sanitizer: DomSanitizer,
    private uploadService: UploadService,
  ) { }
  
  
  ngOnInit(): void {
    this.formApi = this._formBuilder.group({
      id: [null],
      ativo: [null],
      name: [null, Validators.required],
      empresa_id: [null],
      email: [null, Validators.required],
      password: [null],
      grupo_usuario_id: [null],
      usuario_interno: [null],
      api_key: [null],
      secret: [null],
      url_imagem_usuario: [null],
    })
    this.index()
    this.listEmpresas()
    this.listGruposUsuario()
    this.setupEmpresaIdObserver();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.calculateScrollHeight();
    }, 200);
  }

  calculateScrollHeight(): void {
    if (this.tableWrapper && this.tableWrapper.nativeElement) {
      const wrapperHeight = this.tableWrapper.nativeElement.offsetHeight;
      const calculatedHeight = wrapperHeight - 120;
      this.scrollHeight = `${Math.max(calculatedHeight, 300)}px`;
    }
  }

  isEmailValid() {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(this.form.get('email').value);
}

  openNewApi() {
    this.isEditing = false
    this.formApi.reset()
    this.formApi.get('ativo').setValue(true)
    this.displayModalApi = true
    this.setupEmpresaIdObserver()
  }

  index(){
    this.data = []
    this.usuarioService.listarAPIs().subscribe(json => {
     this.data = json || [];
     setTimeout(() => {
       this.calculateScrollHeight();
     }, 200);
    })
  }

  listEmpresas(){
    this.dropDownEmpresas = []
    this.pessoaService.listEmpresas().subscribe(json => {
      (json || [])
        .filter((item: any) => item.ativo === true)
        .forEach((item: any) => {
          this.dropDownEmpresas.push({
            value: Number(item.id), label: item.nome
          })
        })
      this.dropDownEmpresas.sort((a, b) =>
        a.label.localeCompare(b.label, 'pt-BR', { sensitivity: 'base' })
      )
    })
  }

  listGruposUsuario(){
    this.dropDownGrupos = [{
      value: 'null', label: 'Selecione'
    }]
    this._grupoUsuarioService.index().subscribe(json => {
      json.map(item => {
        if(item.ativo == true){
          this.dropDownGrupos.push({
            value: item.id, label: item.nome
          })
        }
      })
    })
  }

  private showDownloadConfirmation(needsApiKey: boolean, needsSecret: boolean): Promise<boolean> {
    return new Promise((resolve) => {
      let message = 'Você ainda não baixou:';
      if (needsApiKey) message += '\n- API Key';
      if (needsSecret) message += '\n- Secret';
      message += '\n\nDeseja baixar agora?';
      
      this.confirmationService.confirm({
        key: 'globalConfirm',
        message: message,
        header: 'Confirmar Download',
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: 'Sim',
        rejectLabel: 'Não, salvar mesmo assim',
        accept: () => {
          if (needsApiKey) this.downloadFile('api_key.txt', this.formApi.get('api_key').value);
          if (needsSecret) this.downloadFile('secret.txt', this.formApi.get('secret').value);
          resolve(true);
        },
        reject: () => {
          resolve(true);
        }
      });
    });
  }

  async saveApi () {
    const needsApiKeyConfirm = this.formApi.get('api_key').value && !this.apiKeyDownloaded && !this.isEditing;
    const needsSecretConfirm = this.formApi.get('secret').value && !this.secretDownloaded;

    if (needsApiKeyConfirm || needsSecretConfirm) {
      const confirmed = await this.showDownloadConfirmation(needsApiKeyConfirm, needsSecretConfirm);
      if (!confirmed) {
        return;
      }
    }
    let form = this.formApi.value;
    let params = {
      usuario: {
        ativo: form.ativo,
        name: form.name,
        empresa_id: form.empresa_id != null ? Number(form.empresa_id) : null,
        email: form.email,
        password: form.password,
        api_key: form.api_key,
        secret: form.secret,
        tipo: 1,
      }
    }

    if(form.id == null){
      this.usuarioService.store(params).subscribe(json => {
        this.index()
        this.displayModalApi = false
      })
    } else {
      this.usuarioService.update(params, form.id).subscribe(json => {
        this.index()
        this.displayModalApi = false
      })
    }

    this.apiKeyDownloaded = false;
    this.secretDownloaded = false;
    this.isEditing = false;
  }

  generateRandomPassword(length: number): string {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    return Array.from({length}, () => chars[Math.floor(Math.random() * chars.length)]).join('');
  }

  generateUUID(): string {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  generateRandomSecret(length: number): string {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()';
    return Array.from({length}, () => chars[Math.floor(Math.random() * chars.length)]).join('');
  }

  setupEmpresaIdObserver() {
    if (this.empresaIdSubscription) {
      this.empresaIdSubscription.unsubscribe();
    }
    
    this.empresaIdSubscription = this.formApi.get('empresa_id').valueChanges.pipe(
      distinctUntilChanged((prev, curr) => Number(prev) === Number(curr))
    ).subscribe((empresaId) => {
      if (this.isEditing) return;

      const empresaSelecionada = this.dropDownEmpresas.find(
        e => Number(e.value) === Number(empresaId)
      );
      
      if (empresaSelecionada) {
        this.formApi.patchValue({
          name: `${empresaSelecionada.label}-api`,
          email: `${empresaSelecionada.label.toLowerCase().replace(/\s+/g, '_')}@email.com`,
          password: this.generateRandomPassword(6),
          api_key: this.generateUUID(),
          secret: this.generateRandomSecret(36)
        }, { emitEvent: false });
        
        this.apiKeyDownloaded = false;
        this.secretDownloaded = false;
      }
    });
  }

  downloadFile(filename: string, content: string) {
    const element = document.createElement('a');
    element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(content));
    element.setAttribute('download', filename);
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
    
    if (filename === 'api_key.txt') {
      this.apiKeyDownloaded = true;
    } else if (filename === 'secret.txt') {
      this.secretDownloaded = true;
    }
  }

  generateNewSecret() {
    const newSecret = this.generateRandomSecret(36);
    this.formApi.patchValue({
      secret: newSecret
    });
    this.secretDownloaded = false;
  }

  editApi(event) {
    this.formApi.reset()
    this.isEditing = true;
    this.apiKeyDownloaded = true;
    this.secretDownloaded = true;

    this.usuarioService.show(event.id).subscribe(json => {
      this.formApi.patchValue(json);
      if (json.empresa_id != null) {
        this.formApi.get('empresa_id').setValue(Number(json.empresa_id))
      }
      this.displayModalApi = true;
    })
  }

  /**
   * Confirmação Sim/Não antes de excluir. Chama DELETE /api/usuario/{id} (mesma API de excluir usuário).
   * Documentação: 204 sucesso; 401 não autenticado; 403 não pode excluir a si mesmo; 404 usuário não encontrado.
   */
  confirmarExclusao(usuario: any): void {
    const nome = usuario.name || usuario.email || `ID ${usuario.id}`;
    this.confirmationService.confirm({
      key: 'globalConfirm',
      message: `Deseja realmente excluir o usuário API "${nome}" (código ${usuario.id})?`,
      header: 'Confirmar exclusão',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Sim, excluir',
      rejectLabel: 'Cancelar',
      acceptButtonStyleClass: 'p-button-danger',
      accept: () => this.excluirUsuario(usuario.id),
    });
  }

  private excluirUsuario(id: number): void {
    this.usuarioService.destroy(id).subscribe({
      next: () => {
        this.data = this.data.filter((item: any) => item.id !== id);
        this.messageService.add({
          severity: 'success',
          summary: 'Sucesso',
          detail: 'Usuário API excluído com sucesso.',
        });
        setTimeout(() => this.calculateScrollHeight(), 200);
      },
      error: (err) => {
        const status = err?.status;
        const body = err?.error || {};
        const msg = body?.message || body?.error || 'Não foi possível excluir o usuário.';
        if (status === 404) {
          this.data = this.data.filter((item: any) => item.id !== id);
          this.messageService.add({
            severity: 'warn',
            summary: 'Atenção',
            detail: msg,
          });
        } else if (status === 403) {
          this.messageService.add({
            severity: 'warn',
            summary: 'Não permitido',
            detail: msg,
          });
        } else if (status === 401) {
          this.messageService.add({
            severity: 'error',
            summary: 'Erro',
            detail: msg,
          });
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Erro',
            detail: msg,
          });
        }
      },
    });
  }
}
